// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jOauX","col":"styles_col__1HJGS","actions":"styles_actions__2OEZD","conflict":"styles_conflict__2jQVS"};